// AWS Amplify polyfill
if (window.global === undefined) {
    window.global = window;
}
    